// Sandbox 3 speed fix A: load only Swiper core + the two modules used (was the full bundle, ~34 files), pinned to the version of assets/swiper-bundle.min.css
import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12.0.3/swiper.min.mjs'
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@12.0.3/modules/navigation.min.mjs'
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@12.0.3/modules/pagination.min.mjs'

class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    // console.log('CustomSlider connectedCallback', {this});
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      this.initSlider()
    }
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

  initSlider() {
    // Scoped to this element so it no longer grabs every .swiper on the page
    const el = this.querySelector('.swiper')
    if (!el || this.slider) return
    const nextEl = this.querySelector('.swiper-button-next')
    const prevEl = this.querySelector('.swiper-button-prev')
    const dotsEl = this.querySelector('.swiper-pagination')
    const options = {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      spaceBetween: 10,
      autoHeight: false,
    }
    if (nextEl && prevEl) {
      options.navigation = { nextEl, prevEl }
      // Keep the arrows visible even when every slide fits on screen (they show greyed out)
      options.watchOverflow = false
    }
    if (dotsEl) options.pagination = { el: dotsEl, type: 'bullets' }
    this.slider = new Swiper(el, options);
  }
}

if (!customElements.get('custom-slider')) {
  customElements.define('custom-slider', CustomSlider)
}
